<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.1031 12.4148H4.97607V10.9148H17.1031L11.4068 5.21855L12.4761 4.16479L19.9761 11.6648L12.4761 19.1648L11.4068 18.111L17.1031 12.4148Z" fill="currentColor"/>
</svg>
